import { lazy, Suspense } from 'react';
import type { ReactNode } from 'react';
import type { RouteObject } from 'react-router-dom';

import { ProtectedRoute } from '@/auth/ProtectedRoute';
import { ROUTE_CHECKS } from '@/components/layout/admin-nav';
import { RouteErrorBoundary } from '@/components/RouteErrorBoundary';
import { RouteFallback } from '@/components/RouteFallback';

const IntegrationStatusPage = lazy(() => import('./pages/IntegrationStatusPage'));

function withSuspense(node: ReactNode): ReactNode {
  return <Suspense fallback={<RouteFallback />}>{node}</Suspense>;
}

/** Platform-wide integration status (System Admin), under the admin layout. */
export const integrationStatusRoutes: RouteObject[] = [
  {
    path: 'integration-status',
    element: withSuspense(
      <ProtectedRoute requires={ROUTE_CHECKS.integrationStatus}>
        <IntegrationStatusPage />
      </ProtectedRoute>,
    ),
    errorElement: <RouteErrorBoundary />,
  },
];
